import { System } from './system';

export class FileSystem extends System {
  constructor() {
    super();
  }
}
